/* eslint-disable @typescript-eslint/no-extraneous-class -- needed*/

import type { JavaScriptFunction } from '@unifyapps/defs/types/javascriptFunction';
import { RunBehaviourEnums } from '@unifyapps/defs/types/javascriptFunction';

class PageFunctionHelper {
  /**
   * check if function is automatic
   */
  static isAutomatic(pageFunction?: JavaScriptFunction) {
    if (!pageFunction) return false;
    // if runBehaviour is not defined, default to automatic for backward compatibility
    return (
      pageFunction.runBehaviour === RunBehaviourEnums.AUTOMATIC ||
      pageFunction.runBehaviour === undefined
    );
  }

  /**
   * check if function is manual
   */
  static isManual(pageFunction?: JavaScriptFunction) {
    if (!pageFunction) return false;
    return pageFunction.runBehaviour === RunBehaviourEnums.MANUAL;
  }

  /**
   * get all automatic functions from page functions record
   * optimized to avoid multiple filter passes and unnecessary allocations
   */
  static getAutomaticFncs(pageFunctions: Record<string, JavaScriptFunction | undefined>) {
    const result: JavaScriptFunction[] = [];
    for (const fn of Object.values(pageFunctions)) {
      if (fn && PageFunctionHelper.isAutomatic(fn)) {
        result.push(fn);
      }
    }
    return result;
  }

  /**
   * get all manual functions from page functions record
   * optimized to avoid multiple filter passes and unnecessary allocations
   */
  static getManualFncs(pageFunctions: Record<string, JavaScriptFunction | undefined>) {
    const result: JavaScriptFunction[] = [];
    for (const fn of Object.values(pageFunctions)) {
      if (fn && PageFunctionHelper.isManual(fn)) {
        result.push(fn);
      }
    }
    return result;
  }
}

export default PageFunctionHelper;
